/**
 * DOM-узел для порталов и общих операций внутри хоста виджета.
 * В embed-режиме React монтируется в #larte-chat-widget-container; в dev — в #root с #larte-chat-widget-root.
 */

export function getWidgetPortalHost(): HTMLElement {
  return (
    document.getElementById('larte-chat-widget-container') ||
    document.getElementById('larte-chat-widget-root') ||
    document.body
  );
}

export function queryLauncherTrigger(root: HTMLElement | null): HTMLButtonElement | null {
  if (!root) return null;
  return root.querySelector<HTMLButtonElement>('button[aria-label="Открыть чат"]');
}

export function isLauncherTriggerHidden(button: HTMLButtonElement | null): boolean {
  if (!button) return false;
  const cs = window.getComputedStyle(button);
  if (cs.display === 'none' || cs.visibility === 'hidden') return true;
  if (cs.opacity === '0' && cs.pointerEvents === 'none') return true;
  const r = button.getBoundingClientRect();
  if (r.width < 0.5 || r.height < 0.5) return true;
  return false;
}
